//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

let vm = null;
import secondaryPageTitle from '../../components/secondary_page_title.vue'
import { mapState } from 'vuex'
import wx from 'weixin-jsapi';
import { Button, Field, Notify, Popup, Icon } from 'vant';
import user from '../../components/user.vue'
import {
  getLiveInfo,
  getUserInfo,
  joinLive,
  checkLivePsw,
  addOrder,
  orderPay,
  orderPayH5,
  earnestInfo,
  collectEarnest,
  changeOrder,
  saveUserViewRecord,
  liveShare,
  liveAppointment,
  getShare,
  saveInvitationInfo,
  clickPhone,
  getShareUserInfo,
  alertMess,
  getJoinTipContent,
  getUnionInfo,
  alertLiveMess,
  getZhaoshangUserByToken
} from '../../../api/index'
import config from '../../../config'
import $ from "jquery"
import html2canvas from 'html2canvas'

export default {
  name: "live",
  data () {
    return {
      exhibition_video_list: [],
      live_lb_list: [],
      timer0: "",
      showToggle: true,
      toggleList: [],
      toggle_idx: -1,
      title: '',
      zx_message: '',
      isShowTip: -1, //2表示报名
      is_appointment: '',
      live_src: '',
      drawLiveData: {
        width: 750,
        height: 1344,
        views: [
          //背景图
          {
            type: 'image',
            url: '',
            left: 0,
            top: 0,
            width: 750,
            height: 1344
          },
          //头像
          {
            type: 'image',
            url: '',
            width: 148,
            height: 148,
            top: 206,
            left: 303,
            borderRadius: 148,
            objectFit: 'cover'
          },
          //好友
          {
            type: 'text',
            content: '',
            left: 373,
            top: 438,
            fontSize: 30,
            color: '',
            textAlign: 'center',
            width: 400,
            lineNum: 1
          },
          {
            type: 'text',
            content: '邀请您一起看直播',
            left: 373,
            top: 478,
            fontSize: 30,
            color: '',
            textAlign: 'center'
          },
          //大图
          {
            type: 'image',
            url: '',
            width: 503,
            height: 282,
            top: 510,
            left: 125
          },
          //直播图标
          {
            type: 'image',
            url: require('../../assets/img/circle.png'),
            width: 61,
            height: 61,
            top: 622,
            left: 350
          },
          //二维码
          {
            type: 'image',
            url: '',
            width: 180,
            height: 180,
            top: 848,
            left: 287
          },
          //长按识别文字
          {
            type: 'text',
            content: '长按识别二维码',
            left: 374,
            top: 1081,
            fontSize: 24,
            color: '#464646',
            textAlign: 'center'
          },
          {
            type: 'text',
            content: '进 入 直 播 间',
            left: 374,
            top: 1111,
            fontSize: 24,
            color: '#464646',
            textAlign: 'center'
          },
          //品牌logo
          {
            type: 'image',
            url: '',
            width: 203,
            height: 76,
            top: 1133,
            left: 273
          },
          //底部文字
          {
            type: 'text',
            content: '',
            left: 370,
            top: 1305,
            fontSize: 22,
            color: '#fff',
            textAlign: 'center',
            width: 500,
            lineNum: 2
          }
        ]
      },
      show_share_zb: false,
      show_ask: false,
      contact_tel: '',
      contact_tel2: '',
      show_tip_jj: false,
      show_tip_bm: false,
      show_tip_shz: false,
      orderSucc: '',
      show_earnest: false,
      cyj_active: '',
      show_psw: false,
      show_user: false,
      live_psw: '',
      target_id: 0,
      time_stamp: '',
      timer: '',
      timer1: null,
      day: '00',
      hour: '00',
      minute: '00',
      live_data: '',
      is_zs_ex: 0,
      //预售金轮播
      cyj_idx: '',
      message: '',
      //预售金
      cyj_list: [],
      live_info: {},
      user_info: {},
      user_obj: {},
      live_sign_num: 0,
      is_ex_live_bm: 0,
      user_status: 0,
      user_join_live_status: -1,
      live_join_audit_result: '',
      earnest: {},
      brand_info: {},
      earnest_item: {},
      isActive: false,
      url_domain: '',
      live_id: 0,
      refund_tip_content: '',
      vr_url: '',
      showIframe: false,
    }
  },
  components: {
    user,
    secondaryPageTitle
  },
  methods: {
    closeIframe () {
      this.showIframe = false
    },
    toWatchVR (url) {
      if (url) {
        this.vr_url = url
        this.showIframe = true
      }
    },
    videoDetail (e) {
      let _this = this
      if (e.target.attributes['data-id']) {
        var id = e.target.attributes['data-id'].value
        let url = config.baseUrl + 'wap-view/video/' + id + '/' + _this.$route.params.id + '/' + localStorage.getItem('ex_id') + '/0/0/0/0/0?playStatus=' + (_this.$store.state.playStatus == 0 ? 0 : 3)
        window.location.href = url;
        return;
      }
    },
    slideWidth (percent, padding) {
      return window.innerWidth * (1 - padding / 375) / percent;
    },
    getIsActive () {
      this.isActive = true
      setTimeout(() => {
        this.isActive = false
      }, 900)
    },
    successDrawLive (src) {
      this.live_src = src
    },
    submitZx () {
      let _this = this
      if (_this.zx_message == '') {
        Notify({ type: 'danger', message: '请输入留言', duration: 1500 });
        return;
      }
      let obj = {}
      obj.exa_id = _this.live_info.ex_id
      obj.openid = localStorage.getItem('openid')
      obj.type = 2
      obj.remark = _this.zx_message
      saveInvitationInfo(obj).then(res => {
        if (res.code == 0) {
          Notify({ type: 'success', message: '提交成功', duration: 1500 });
          _this.show_ask = false
        } else {
          Notify({ type: 'danger', message: res.text, duration: 1500 });
        }
      })
    },
    getName (name) {
      this.user_info.name = name
    },
    closeShowUser () {
      this.show_user = false;
    },
    apply () {
      let appid = config.appid; //公众号appid
      let template_id = config.template_id
      let redirect_url = encodeURIComponent(window.location.href)
      window.location.href = 'https://mp.weixin.qq.com/mp/subscribemsg?action=get_confirm&appid=' + appid + '&scene=1000&template_id=' + template_id + '&redirect_url=' + redirect_url + '&reserved=test#wechat_redirect'
    },
    bodyScroll (event) {
      event.preventDefault();
    },
    showAsk (name = '', area_id = 0) {
      this.isShowTip = 1
      this.user_info.name = name
      this.user_info.area_id = area_id
      if (this.user_info.type == 1) {
        Notify({ type: 'danger', message: '招商经理无法进行该操作', duration: 1500 });
        return;
      } else if (this.user_info.name == '' || this.user_info.area_id == 0) {
        this.show_user = true;
        return;
      } else {
        this.show_ask = true
      }
    },
    trigerClickPhone (name, area_id = 0) {
      let _this = this
      _this.user_info.name = name
      _this.user_info.area_id = area_id
      setTimeout(() => {
        _this.$refs.click_phone.click()
      }, 500)
    },
    clickPhone () {
      let _this = this
      _this.isShowTip = 5
      if (this.user_info.type == 1) {
        Notify({ type: 'danger', message: '招商经理无法进行该操作', duration: 1500 });
        return;
      } else if (this.user_info.name == '' || this.user_info.area_id == 0) {
        this.show_user = true;
        return;
      }
      let obj = {}
      obj.live_id = _this.live_info.id
      obj.exa_id = _this.live_info.ex_id
      obj.openid = localStorage.getItem('openid')
      clickPhone(obj).then(res => {

      })
    },
    slideTo (index) {
      this.cyj_idx = index
      setTimeout(() => {
        if (this.$refs.mySwiper) {
          this.$refs.mySwiper.swipeTo(this.cyj_idx, 1000, false)
        }
      }, 0)
    },
    showEarnest (e) {
      if (e.target.attributes['data-id']) {
        this.cyj_active = e.target.attributes['data-id'].value
        this.getEarnestInfo(e.target.attributes['data-id'].value);
      }
    },
    changeEarnest (e) {
      if (e.target.attributes['data-id']) {
        this.getEarnestInfo(e.target.attributes['data-id'].value);
        //console.log(e.target.attributes['data-id'].value)
      }
    },
    getEarnestInfo (e_id) {
      let obj = {}
      obj.id = e_id
      obj.openid = localStorage.getItem('openid')
      obj.user_phone = this.user_phone
      earnestInfo(obj).then(res => {
        if (res.code == 0) {
          this.earnest = res.data
          this.orderSucc = this.earnest.is_buy
          this.$nextTick(() => {
            if (document.getElementById('show_earnest')) {
              document.getElementById('show_earnest').scrollTop = 0
            }
          })
          this.show_earnest = true
        } else {
          Notify({ type: 'danger', message: res.text, duration: 1500 });
        }
      })
    },
    getLiveDate (start_time) {
      let _this = this
      var liveDate = new Date(start_time * 1000)
      var month = parseInt(liveDate.getMonth() + 1)
      var day = liveDate.getDate()
      var hour = liveDate.getHours()
      var minute = liveDate.getMinutes()
      _this.live_data = month + "月" + _this.getzf(day) + "日" + ' ' + _this.getzf(hour) + ":" + _this.getzf(minute)
    },
    //转换年月日方法
    getDate (format, str) {
      var oDate = new Date(str * 1000), //时间戳为10位需*1000，时间戳为13位的话不需乘1000
        oYear = oDate.getFullYear(),
        oMonth = oDate.getMonth() + 1,
        oDay = oDate.getDate(),
        oHour = oDate.getHours(),
        oMin = oDate.getMinutes(),
        oSec = oDate.getSeconds();
      var oTime = ''
      if (format == 'YYYY-MM-DD HH:MM:SS') {
        oTime = oYear + '-' + this.getzf(oMonth) + '-' + this.getzf(oDay) + ' ' + this.getzf(oHour) + ':' + this.getzf(oMin) + ':' + this.getzf(oSec);//最后拼接时间
      } else if (format == 'yyyy/mm/dd') {
        oTime = oYear + '/' + this.getzf(oMonth) + '/' + this.getzf(oDay) + ' ' + this.getzf(oHour) + ':' + this.getzf(oMin) + ':' + this.getzf(oSec);//最后拼接时间
      }
      return oTime;
    },
    //补0操作
    getzf (num) {
      if (parseInt(num) < 10) {
        num = '0' + num;
      }
      return num;
    },
    computeTime () {
      var time0 = this.getDate('YYYY-MM-DD HH:MM:SS', this.time_stamp);
      //var time0 = '2020-05-12 12:00:00';
      var time = new Date(time0.replace(/-/g, "/"));
      var diff = '';
      var days = '00'
      var hours = '00'
      var minutes = '00'
      var seconds = '00'
      var time_diff = time.getTime() - new Date().getTime();
      //console.log(time.getTime())
      //console.log(new Date().getTime());return;
      if (time_diff > 0) {
        // 计算相差天数
        days = Math.floor(time_diff / (24 * 3600 * 1000));
        if (days > 0) {
          diff += days + '天';
        }
        // 计算相差小时数
        var leave1 = time_diff % (24 * 3600 * 1000);
        hours = Math.floor(leave1 / (3600 * 1000));
        if (hours > 0) {
          diff += hours + '时';
        } else {
          if (diff !== '') {
            diff += hours + '时';
          }
        }
        // 计算相差分钟数
        var leave2 = leave1 % (3600 * 1000);
        minutes = Math.floor(leave2 / (60 * 1000));
        if (minutes > 0) {
          diff += minutes + '分';
        } else {
          if (diff !== '') {
            diff += minutes + '分';
          }
        }
        // 计算相差秒数
        var leave3 = leave2 % (60 * 1000);
        seconds = Math.round(leave3 / 1000);
        if (seconds > 0) {
          diff += seconds + '秒';
        } else {
          if (diff !== '') {
            diff += seconds + '秒';
          }
        }
      }
      this.timer = diff;
      this.day = days;
      this.hour = hours;
      this.minute = minutes;
    },
    pswBeforeClose () {
      let _this = this
      if (_this.live_psw == '') {
        Notify({ type: 'danger', message: '请输入密码', duration: 1500 });
        return
      }
      let obj = {}
      obj.live_id = _this.$route.params.live_id
      obj.view_type_val = _this.live_psw
      checkLivePsw(obj).then(res => {
        if (res.code == 0) {
          _this.joinLiveSubmit()
        } else {
          Notify({ type: 'danger', message: res.text, duration: 1500 });
          return
        }
      })
    },
    getStatusName () {
      let _this = this
      if (_this.user_join_live_status == -2) {
        return '踢出直播间'
      } else if (_this.user_join_live_status == -1) {
        return '我要报名'
      } else if (_this.user_join_live_status == 0) {
        return '报名审核中'
      } else if (_this.user_join_live_status == 1) {
        return '立即分享'
      } else if (_this.user_join_live_status == 2 || _this.user_join_live_status == 3) {
        return '报名审核拒绝'
      } else if (_this.user_join_live_status == 4) {
        return '已被加入黑名单'
      }
    },
    targetHome () {
      let url = config.baseUrl + 'wap-view/home/' + this.live_info.ex_id
      window.location.href = url
    },
    targetUserCenter () {
      let _this = this
      if (this.user_info.type == 0) {
        let url = config.baseUrl + 'wap-view/ordinary-user/index'
        window.location.href = url
      } else {
        let url = config.baseUrl + 'wap-view/leasing-manager/index'
        window.location.href = url
      }
    },
    closeUser () {
      let _this = this
      _this.show_user = false
    },
    joinLive (name = '', area_id = 0) {
      let _this = this
      if (_this.user_join_live_status == -1) {//未报名
        if (_this.user_info.type == 1) {
          Notify({ type: 'danger', message: '招商经理无法进行该操作', duration: 1500 });
          return
        }
        _this.isShowTip = 2
        _this.user_info.name = name
        _this.user_info.area_id = area_id
        if (_this.user_info.name == '' || _this.user_info.area_id == 0) {
          _this.show_user = true;
          return;
        }
        if (_this.live_info.view_type == 1) {//付费
          if (_this.is_ex_live_bm) {//判断是否在平台报名过，如果已经报名，直接走报名流程无需再次支付
            //生成虚拟报名订单
            let order_obj = {}
            order_obj.exa_id = _this.live_info.ex_id
            order_obj.live_id = _this.$route.params.live_id
            order_obj.user_id = _this.user_info.id
            order_obj.unit_price = _this.live_info.view_money
            order_obj.num = 1
            order_obj.type = 1
            order_obj.state = 1
            order_obj.order_type = 6
            order_obj.client_type = _this.$store.state.isApp ? 2 : 1
            addOrder(order_obj).then(res => {
              if (res.code == 0) {
                _this.target_id = res.data.id
                _this.joinLiveSubmit()
              }
            })
          } else {
            _this.show_tip_bm = true;
          }
          return;
        } else {
          _this.joinLiveSure()
        }
        var timestamp = Date.parse(new Date());
        if (_this.live_info.end_at < timestamp / 1000 && _this.live_info.status == 0) {
          _this.live_info.status = 2
        }
      }
      if (_this.user_join_live_status == 0) {//未报名
        _this.show_tip_shz = true;
        return;
      }
      if (_this.user_join_live_status == 2) {//未报名
        _this.show_tip_jj = true;
        return;
      }
      if (_this.user_join_live_status == 1) {
        _this.showShare();
      }
    },
    showShare () {
      let _this = this
      _this.shareLive();
      let obj = {}
      obj.live_id = _this.$route.params.live_id
      getShare(obj).then(res => {
        if (res.code == 0) {
          this.live_info.share_num++
        }
      })
    },
    shareLive () {
      let _this = this
      let obj = {}
      obj.openid = localStorage.getItem('openid')
      obj.user_phone = _this.user_phone
      obj.live_id = this.$route.params.live_id
      _this.$store.commit('updateLoading', true)
      liveShare(obj).then(res => {
        if (res.code == 0) {
          _this.drawLiveData.views[0].url = res.data.live_share_img
          _this.drawLiveData.views[2].color = '#' + res.data.live_share_color
          _this.drawLiveData.views[3].color = '#' + res.data.live_share_color
          _this.drawLiveData.views[1].url = res.data.user_icon
          _this.drawLiveData.views[2].content = '您的好友' + res.data.user_name
          _this.drawLiveData.views[4].url = res.data.img
          _this.drawLiveData.views[6].url = res.data.ewm_url
          _this.drawLiveData.views[9].url = res.data.brand_logo
          _this.drawLiveData.views[10].content = res.data.brand_name + '正在参加' + res.data.ex_name
          _this.$nextTick(() => {
            setTimeout(() => {
              _this.$store.commit('updateLoading', false)
              _this.show_share_zb = true
            }, 1000)
          })
        }
      })
    },
    //点击我要报名
    joinLiveSure () {
      let _this = this
      _this.show_tip_bm = false;
      //判断授权情况
      if (_this.user_info.type == 1 && !_this.is_zs_ex) {
        Notify({ type: 'danger', message: '招商经理无法进行该操作', duration: 1500 })
      } else if (_this.user_info.name == '' || _this.user_info.area_id == 0) {
        if (this.$store.state.isApp) {//APP环境
          app.jumpLogin()
        } else {
          _this.show_user = true
        }
      } else {
        if (_this.live_info.view_type == 1) {//付费进入直播间
          //下单
          let order_obj = {}
          order_obj.exa_id = _this.live_info.ex_id
          order_obj.live_id = _this.$route.params.live_id
          order_obj.user_id = _this.user_info.id
          order_obj.unit_price = _this.live_info.view_money
          order_obj.num = 1
          order_obj.type = 1
          order_obj.client_type = _this.$store.state.isApp ? 2 : 1
          addOrder(order_obj).then(res => {
            if (res.code == 0) {//下单成功，调用微信接口生成预支付订单
              if (_this.$store.state.isWeixin) {//微信环境
                _this.target_id = res.data.id
                let pay_obj = {}
                pay_obj.order_sn = res.data.order_sn
                pay_obj.openid = localStorage.getItem('openid')
                orderPay(pay_obj).then(res1 => {
                  if (res1.code == 0) {//统一下单成功，唤起微信支付
                    if (typeof WeixinJSBridge == "undefined") {//微信浏览器内置对象。参考微信官方文档
                      if (document.addEventListener) {
                        document.addEventListener('WeixinJSBridgeReady', _this.onBridgeReady(res1.data, res1.time_tamp, res1.pay_sign, 1, res.data.order_sn), false);
                      } else if (document.attachEvent) {
                        document.attachEvent('WeixinJSBridgeReady', _this.onBridgeReady(res1.data, res1.time_tamp, res1.pay_sign, 1, res.data.order_sn));
                        document.attachEvent('onWeixinJSBridgeReady', _this.onBridgeReady(res1.data, res1.time_tamp, res1.pay_sign, 1, res.data.order_sn));
                      }
                    } else {
                      _this.onBridgeReady(res1.data, res1.time_tamp, res1.pay_sign, 1, res.data.order_sn);
                    }
                  } else {
                    _this.onBridgeReady(res1.data, res1.time_tamp, res1.pay_sign, 1, res.data.order_sn);
                  }
                })
              } else {//非微信环境需要执行H5支付
                //Notify({ type: 'success', message: '需要执行H5支付', duration: 1500 });return;
                let pay_obj = {}
                pay_obj.order_sn = res.data.order_sn
                orderPayH5(pay_obj).then(res1 => {
                  if (res1.code == 0) {//H5统一下单成功
                    let mweb_url = encodeURIComponent(res1.data.mweb_url)
                    if (this.$store.state.isApp) {//APP环境
                      let pay_url = config.baseUrl + 'wap-view/pay_h5/' + mweb_url + '/' + res.data.order_sn
                      app.openUrl(pay_url)
                    } else {//普通H5环境
                      this.$router.push({
                        name: 'pay_h5',
                        params: { pay_url: mweb_url, order_sn: res.data.order_sn }
                      })
                    }
                  } else {
                    Notify({ type: 'danger', message: res1.text, duration: 1500 });
                  }
                })
              }
            } else {
              Notify({ type: 'danger', message: res.text, duration: 1500 });
            }
          })
        }
        if (_this.live_info.view_type == 2) {//免费，直接进入直播间
          _this.joinLiveSubmit()
        }
        if (_this.live_info.view_type == 3) {//输入密码进入直播间
          _this.show_psw = true
        }
      }
    },
    saveUserViewRecord () {
      let obj = {}
      obj.openid = localStorage.getItem('openid')
      obj.live_id = this.$route.params.live_id
      obj.type = 2
      saveUserViewRecord(obj).then(res1 => {

      })
    },
    collectEarnest (earnest) {
      let _this = this
      if (_this.user_info.type == 1) {
        Notify({ type: 'danger', message: '招商经理无法进行该操作', duration: 1500 });
        return;
      } else {
        //调用收藏接口
        let obj = {}
        obj.openid = localStorage.getItem('openid')
        obj.user_phone = _this.user_phone
        obj.eid = earnest.id
        collectEarnest(obj).then(res => {
          if (res.code == 0) {
            earnest.is_collect = earnest.is_collect ? 0 : 1
            let msg = earnest.is_collect ? '加入收藏成功' : '取消收藏成功'
            Notify({ type: 'success', message: msg, duration: 1500 });
          } else {
            Notify({ type: 'danger', message: res.text, duration: 1500 });
          }
        })
      }
    },

    //购买预售金
    buyEarnest (earnest, area_id = 0) {
      let _this = this
      _this.isShowTip = 4
      _this.earnest_item = earnest
      _this.user_info.area_id = area_id
      if (_this.user_info.type == 1) {
        Notify({ type: 'danger', message: '招商经理无法进行该操作', duration: 1500 });
        return;
      } else if (_this.user_info.name == '' || _this.user_info.area_id == 0) {
        _this.show_user = true;
      } else {
        //调用下单接口
        let order_obj = {}
        order_obj.live_id = _this.$route.params.live_id
        order_obj.exa_id = _this.live_info.ex_id
        order_obj.e_id = earnest.id
        order_obj.user_id = _this.user_info.id
        order_obj.unit_price = earnest.price
        order_obj.num = 1
        order_obj.type = 2
        order_obj.client_type = _this.$store.state.isApp ? 2 : 1
        addOrder(order_obj).then(res => {
          if (res.code == 0) {//下单成功，调用微信接口生成预支付订单
            if (_this.$store.state.isWeixin) {//微信环境
              let pay_obj = {}
              pay_obj.order_sn = res.data.order_sn
              pay_obj.openid = localStorage.getItem('openid')
              orderPay(pay_obj).then(res1 => {
                if (res1.code == 0) {//统一下单成功，唤起微信支付
                  if (typeof WeixinJSBridge == "undefined") {//微信浏览器内置对象。参考微信官方文档
                    if (document.addEventListener) {
                      document.addEventListener('WeixinJSBridgeReady', _this.onBridgeReady(res1.data, res1.time_tamp, res1.pay_sign, 2, res.data.order_sn), false);
                    } else if (document.attachEvent) {
                      document.attachEvent('WeixinJSBridgeReady', _this.onBridgeReady(res1.data, res1.time_tamp, res1.pay_sign, 2, res.data.order_sn));
                      document.attachEvent('onWeixinJSBridgeReady', _this.onBridgeReady(res1.data, res1.time_tamp, res1.pay_sign, 2, res.data.order_sn));
                    }
                  } else {
                    _this.onBridgeReady(res1.data, res1.time_tamp, res1.pay_sign, 2, res.data.order_sn);
                  }
                }
              })
            } else {
              let pay_obj = {}
              pay_obj.order_sn = res.data.order_sn
              orderPayH5(pay_obj).then(res1 => {
                if (res1.code == 0) {//H5统一下单成功
                  let mweb_url = encodeURIComponent(res1.data.mweb_url)
                  if (this.$store.state.isApp) {//APP环境
                    let pay_url = config.baseUrl + 'wap-view/pay_h5/' + mweb_url + '/' + res.data.order_sn
                    app.openUrl(pay_url)
                  } else {//普通H5环境
                    this.$router.push({
                      name: 'pay_h5',
                      params: { pay_url: mweb_url, order_sn: res.data.order_sn }
                    })
                  }
                } else {
                  Notify({ type: 'danger', message: res1.text, duration: 1500 });
                }
              })
            }
          } else {
            Notify({ type: 'danger', message: res.text, duration: 1500 });
          }
        })
      }
    },
    //唤醒微信支付
    onBridgeReady (data, time_tamp, pay_sign, type, order_sn) {
      let _this = this
      let url = config.baseUrl + 'wap-view/pay/' + data.appid + '/' + time_tamp + '/' + data.nonce_str + '/' + data.prepay_id + '/' + pay_sign + '/' + order_sn + '/' + type + '/' + _this.$route.params.live_id + '/' + _this.user_info.id + '/' + _this.target_id + '/2'
      window.location.href = url
    },

    //订单回调
    orderCallback (order_sn) {
      let _this = this
      let obj = {}
      obj.order_sn = order_sn
      changeOrder(obj).then(res => {
        if (res.code == 0) {
          _this.orderSucc = 1
          _this.earnest.sale_count++
          Notify({ type: 'success', message: '购买成功', duration: 1500 });
        } else {
          Notify({ type: 'danger', message: res.text, duration: 1500 });
        }
      })
    },

    //报名数据提交
    joinLiveSubmit () {
      let _this = this
      let obj = {}
      obj.live_id = _this.$route.params.live_id
      obj.user_id = _this.user_info.id
      obj.view_type_val = _this.live_psw
      obj.join_type = _this.live_info.view_type
      obj.target_id = _this.target_id
      joinLive(obj).then(res => {
        if (res.code == 0) {
          _this.live_sign_num = parseInt(_this.live_sign_num + 1)
          Notify({ type: 'success', message: '报名成功', duration: 1500 });
          setTimeout(function () {
            _this.user_join_live_status = res.user_join_live_status
            _this.show_psw = false
            if (res.user_join_live_status == 1) {//免审,请求接口判断直播是否开始
              let live_obj = {}
              live_obj.id = _this.$route.params.live_id
              live_obj.openid = localStorage.getItem('openid')
              getLiveInfo(live_obj).then(res1 => {
                if (res1.live_info.status == 1) {//直播已经开始，直接进入直播间
                  let host = window.location.host
                  let host_arr = host.split('.')
                  //let new_host = _this.url_domain+'.'+host_arr[1]+'.'+host_arr[2]
                  let new_host = host_arr[0] + '.' + host_arr[1] + '.' + host_arr[2]
                  let new_url = 'http://' + new_host + '/wap-view/play/' + _this.$route.params.live_id + '?playStatus=' + (_this.$store.state.playStatus == 0 ? 0 : 3)
                  window.location.replace(new_url)
                }
              })
            }
          }, 1500);
        } else {
          Notify({ type: 'danger', message: res.text, duration: 1500 });
        }
      })
    },

    //加入聊天室
    joinChatRoom () {
      let _this = this
      let im = _this.im
      var chatRoom = im.ChatRoom.get({
        id: _this.live_info.chat_room_code
      });
      chatRoom.join({
        count: 1 // 进入后, 自动拉取 20 条聊天室最新消息
      }).then(function () {
        //console.log('加入聊天室成功');
      });
    },
    //初始化融云服务器
    initRongyun () {
      let _this = this
      //融云初始化
      var ry_config = {
        appkey: config.rongyun_key,
      };
      _this.im = RongIMLib.init(ry_config);

      //设置消息监听
      var conversationList = []; // 当前已存在的会话列表
      _this.im.watch({
        conversation: function (event) {
          var updatedConversationList = event.updatedConversationList; // 更新的会话列表
        },
        message: function (event) {
          var message = event.message;
          console.log(message)
          if (message.targetId != _this.live_info.chat_room_code) {
            return;
          }
          if ((message.messageType == 'RCD:LiveStartMsg' && _this.user_join_live_status == 1 && _this.live_info.status == 1) || message.messageType == 'RCD:DeleteBlockUser') {//直播开始自定义消息,需要跳转直播页面
            let host = window.location.host
            let host_arr = host.split('.')
            //let new_host = _this.url_domain+'.'+host_arr[1]+'.'+host_arr[2]
            let new_host = host_arr[0] + '.' + host_arr[1] + '.' + host_arr[2]
            let new_url = 'http://' + new_host + '/wap-view/play/' + _this.$route.params.live_id + '?playStatus=' + (_this.$store.state.playStatus == 0 ? 0 : 3)
            window.location.replace(new_url)
          }
        },
        status: function (event) {
          var status = event.status;
          console.log('连接状态码:', status);
        }
      });
      if (!_this.user_status) {
        //链接融云服务器
        var user = {
          token: _this.user_info.rc_token
        };
        _this.im.connect(user).then(function (user) {
          //console.log('链接成功, 链接用户 id 为: ', user.id);
          _this.joinChatRoom()
        }).catch(function (error) {
          //console.log('链接失败: ', '链接错误1'+error.code, error.msg);
        });
      }
    },
    getLiveInfo (type = 1) {
      let _this = this
      let live_obj = {}
      live_obj.id = _this.$route.params.live_id
      live_obj.openid = type == 1 ? localStorage.getItem('openid') : ''
      live_obj.user_phone = this.user_phone
      live_obj.client_type = type
      live_obj.is_view = 1
      _this.contact_tel = config.contact_tel
      getLiveInfo(live_obj).then(res => {
        if (res.code == 0) {
          let host = window.location.host
          let host_arr = host.split('.')
          if (res.live_info.turn) {
            let url = res.live_info.reserve_url;
            window.location.replace(url);
            return;
          }
          _this.url_domain = res.domain
          _this.is_appointment = res.is_appointment
          _this.live_info = res.live_info
          _this.live_lb_list = res.live_lb_list
          _this.exhibition_video_list = res.exhibition_video_list
          _this.brand_info = res.brand_info
          _this.contact_tel2 = res.brand_info.phone
          _this.time_stamp = res.live_info.start_at
          _this.live_sign_num = res.live_sign_num
          _this.is_ex_live_bm = res.is_ex_live_bm
          _this.getLiveDate(res.live_info.start_at)
          this.cyj_list = res.live_earnest
          _this.title = _this.live_info.name
          if (res.live_info.status == 0) {//直播未开始
            const timer = setInterval(() => {
              this.computeTime();
            }, 500);
            this.$once('hook:beforeDestroy', () => {
              clearInterval(timer);
            })
          }
          let obj = {}
          obj.exa_id = _this.live_info.ex_id
          alertLiveMess(obj).then(res => {
            if (res.code == 0) {
              _this.toggleList = res.data
            }
          })
          let user_obj = {}
          user_obj.live_id = _this.$route.params.live_id
          user_obj.client_type = type
          user_obj.openid = type == 1 ? localStorage.getItem('openid') : ''
          user_obj.user_phone = this.user_phone
          getUserInfo(user_obj).then(res1 => {
            if (res1.code == 0) {
              _this.user_info = res1.user_info
              _this.user_obj.id = res1.user_info.id
              _this.user_obj.name = res1.user_info.name
              _this.user_obj.username = res1.user_info.username
              _this.user_obj.icon = res1.user_info.icon
              _this.user_obj.type = res1.user_info.type
              _this.user_status = res1.user_status
              _this.user_join_live_status = res1.user_join_live_status
              _this.live_join_audit_result = res1.live_join_audit_result
              _this.is_zs_ex = res1.is_zs_ex
              if (res1.user_info.name != '') {
                if (res.live_info.status == 1 && _this.user_join_live_status == 1) {//直播中，直接跳转至直播页
                  _this.$store.commit('updateLiveId', _this.$route.params.live_id)
                  _this.$store.commit('updateShowLive', true)
                  _this.$router.push({
                    name: 'play',
                    params: { live_id: _this.$route.params.live_id }
                  });
                  return;
                } else {
                  _this.initRongyun()
                }
              }
              getShareUserInfo(user_obj).then(res2 => {
                _this.$nextTick(function () {
                  _this.$store.commit('updateLoading', false)
                  let url = config.baseUrl + 'wap-view/live/' + _this.$route.params.live_id + '/' + res2.data.user_id + '/' + res2.data.user_type + '/' + res2.data.ex_id + '/' + _this.live_info.ex_id + '/' + res2.data.share_type
                  if (_this.$store.state.isApp) {//app环境
                    app.setShareInfo(_this.live_info.share_title, _this.live_info.share_img, _this.live_info.share_desc, url)
                  } else {//非app环境
                    _this.setShare(_this.live_info.share_title, _this.live_info.share_img, _this.live_info.share_desc, url, 0, _this.$route.params.live_id)
                  }
                })
              })
            }
          })
        } else {
          let url = config.baseUrl + 'wap-view/union/index'
          //window.location.href = url
        }
      })
    },
    getToken () {
      var token = "";
      var name = 'bearerToken';
      var arr,
        reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
      if (arr = document.cookie.match(reg)) {
        token = unescape(arr[2]);
      }
      return token
    }
  },
  mounted () {
    let _this = this
    getUnionInfo().then(res => {
      if (res.code == 0) {
        document.title = res.data.site_title
      }
    })
    getJoinTipContent().then(res => {
      this.refund_tip_content = res.data
    })
    _this.live_id = _this.$route.params.live_id
    _this.$store.commit('updateLoading', true)
    if (!_this.$store.state.isApp) {//微信环境
      if ((localStorage.getItem('openid') != null && localStorage.getItem('openid') != 'undefined' && localStorage.getItem('openid') != '' && localStorage.getItem('openid') != 0)) {
        let action = this.$route.query.action
        if (action) {
          if (action == 'confirm' || action[action.length - 1] == 'confirm') {
            let apply_obj = {}
            apply_obj.openid = localStorage.getItem('openid')
            apply_obj.live_id = this.$route.params.live_id
            liveAppointment(apply_obj).then(res => {
            })
          }
        }
        _this.getLiveInfo(1)
      }
    } else {//app环境
      let token = this.getToken()
      //let token = 'Bearer 8431ae46-13bd-3a36-866d-2337e363d45c'
      if (typeof (token) == 'undefined' || token == '' || token == 'null') {//未登录：调用app登录
        app.jumpLogin()
      } else {
        let user_obj = {}
        user_obj.token = token
        user_obj.live_id = this.$route.params.live_id
        getZhaoshangUserByToken(user_obj).then(res => {
          if (res.code == 0) {
            this.user_phone = res.data
            _this.getLiveInfo(2)
          } else {
            Notify({ type: 'danger', message: res.text, duration: 1500 });
          }
        })
      }
    }
    this.timer1 = setInterval(this.getIsActive, 3000)
    /**
     *定时器5秒显示下一条数据，显示3秒，停顿2秒
     */
    _this.toggle_idx++
    _this.showToggle = true;
    setTimeout(() => {
      _this.showToggle = false
    }, 3000)

    if (_this.toggleList.length > 0) {
      if (_this.toggle_idx == _this.toggleList.length) {
        _this.toggle_idx = 0
      }
    }
    _this.timer0 = setInterval(() => {
      _this.toggle_idx++
      _this.showToggle = true;
      setTimeout(() => {
        _this.showToggle = false
      }, 3000)
      if (_this.toggleList.length > 0) {
        if (_this.toggle_idx == _this.toggleList.length) {
          _this.toggle_idx = 0
        }
      }
    }, 5000)
  },
  beforeDestroy () {
    let _this = this
    if (_this.im) {
      _this.im.disconnect().then(function () {
        //console.log('断开链接成功');
      });
    }
    //清除定时器
    clearInterval(_this.timer0);
    clearInterval(_this.timer1);
  }
}



// WEBPACK FOOTER //
// ./src/views/live/index.vue